import { render, staticRenderFns } from "./IotModelPointsGroupForm.vue?vue&type=template&id=2e8aea1c&scoped=true&"
import script from "./IotModelPointsGroupForm.vue?vue&type=script&lang=js&"
export * from "./IotModelPointsGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8aea1c",
  null
  
)

export default component.exports